/* eslint-disable react-hooks/exhaustive-deps */
import { useNotification } from 'hooks/notification';
import React, { useEffect, useState } from 'react';
import { Route, useLocation, Redirect } from 'react-router-dom'
import { getRequest } from 'utils/request';
import Swal from "sweetalert2";
import { i18n } from 'translate/i18n';
import { useAuth } from 'hooks/auth';

// import { Container } from './styles';

function PrivateRoute({ component: Component, ...rest }) {
    const [permission, setPermission] = useState(false);
    const { selectedCompany } = useNotification();
    const [link, setLink] = useState('')
    const user = JSON.parse(sessionStorage.getItem('@Omni:user'));
    const location = useLocation();
    const { signOut } = useAuth();

    const getPermissions = () => {
        let path = location.pathname
        .replace(/\d+/g, '');
        if(path[path.length - 1] === '/') {
          path = path.substr(0, path.length - 1);
        }
        if(selectedCompany && selectedCompany.id !== undefined) {
          getRequest(`/menus/isallowed?UserTypeId=${user.UserTypeId}&CompanyId=${selectedCompany.id}&link=${path}`)
          .then((e) => {
            if(e.success) {
                if(e.data.action && (e.data.action === 2 || e.data.action === 3)) {
                    Swal.fire({
                        title: "Erro",
                        text: e.data.action === 2 ? i18n.t('endTrial') : i18n.t('accountExpired'),
                        icon: "warning",
                        confirmButtonText: "Ok",
                    });
                    return signOut();
                }
                if((path || '/') !== e.data.link) {
                    setLink(e.data.link);
                    setPermission(false)
                } else {
                    setPermission(true)
                }
            }
        })}
    }

    useEffect(() => {
        getPermissions();
    }, [location, selectedCompany])

    return (
        <Route
            {...rest}
            render={props => 
                permission ? (
                    <Component {...props} />
                ) : (
                link && 
                    <Redirect to={link}/>
                )
            }
        />
    );
}

export default PrivateRoute;